import { BookingQueryParams } from '@collinsonx/constants/enums';
import CheckAvailability from '@components/CheckAvailability';
import { setItem } from '@lib';
import { convertBookingToBookingState } from 'adapters/bookingDetailsAdapter';
import { BOOKING_MODE } from 'config/constants';
import { ANALYTICS_TAGS, PAGENAMES } from 'config/datadog';
import { DEFAULT_AMEND_PERIOD } from 'config/productDefaultConfig';
import { BOOKING_MODE_STATE, ORIGINAL_BOOKING_DETAILS } from 'config/storage';
import { BookingContext } from 'context/BookingContext';
import useAnalytics from 'hooks/useAnalytics';
import useBookingDetails from 'hooks/useBookingDetails';
import { checkHoursDiff } from 'lib';
import { useRouter } from 'next/router';
import React, { useContext, useEffect } from 'react';
import { filterMissingProperties } from 'utils/stateManagement';

const AmendBooking = () => {
  const trackingPageName = PAGENAMES.BOOKING_AMEND;
  const router = useRouter();
  const { bookingId } = BookingQueryParams;
  const { [bookingId]: emailBookingId } = router.query;
  const { logAction } = useAnalytics();
  const { booking, setBooking } = useContext(BookingContext);
  const { readyToFetchEntitlements, reloadEntitlements } =
    useContext(BookingContext);

  const { bookingDetailsData } = useBookingDetails();

  const bookingDetailsParsed = convertBookingToBookingState(
    bookingDetailsData?.getBookingByID
  );

  useEffect(() => {
    setItem(BOOKING_MODE_STATE, BOOKING_MODE.EDIT);
    logAction({
      action: ANALYTICS_TAGS.ON_PAGE_ENTER_CHECKAVAILABILITY_EDIT,
      page: trackingPageName,
    });

    setBooking({
      ...filterMissingProperties(bookingDetailsParsed),
      bookingDetails: bookingDetailsParsed,
      selectedEntitlementsCount:
        bookingDetailsParsed?.usedEntitlementsCount ?? 0,
    });

    setItem(ORIGINAL_BOOKING_DETAILS, JSON.stringify(bookingDetailsParsed));

    const { departureDate } = bookingDetailsParsed;

    if (!departureDate) return;

    const difference = checkHoursDiff(departureDate, new Date());

    if (difference <= DEFAULT_AMEND_PERIOD) {
      router.push({
        pathname: '/decline-amend',
        query: { bookingId: emailBookingId },
      });
    }
  }, [bookingDetailsData]);

  useEffect(() => {
    if (readyToFetchEntitlements) reloadEntitlements();
  }, [readyToFetchEntitlements]);

  return (
    booking.departureDate && <CheckAvailability pageName={trackingPageName} />
  );
};

export default AmendBooking;
